import React from "react"
import cn from "classnames"
import { HiOutlineEye } from "react-icons/hi"
import { Tooltip } from "components/Core"

interface ListItemCardProps {
  item: any
  onPreview: (item: any) => void
}

const ListItemCard = ({ item, onPreview }: ListItemCardProps) => (
  <div className="w-full bg-white rounded-[12px] border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group mb-3 flex flex-col">
    <div className="flex flex-row justify-between items-center py-4 px-5 border-b border-gray-50 bg-gray-50/30 group-hover:bg-white transition-colors">
      <div className="flex flex-col">
        <span className="text-[13px] font-semibold text-gray-400 uppercase tracking-tight mb-0.5">SKU</span>
        <span className="text-[17px] font-bold text-[#F9004D]">{item.sku}</span>
      </div>
    </div>

    <div className="flex flex-col p-5 gap-3">
      <div className="flex flex-col gap-3">
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-col flex-1 mr-4">
            <span className="text-[12px] font-medium text-gray-400 uppercase tracking-tight mb-1">Serie SAP</span>
            <span className="text-[15px] font-medium text-gray-800 line-clamp-2">
              {item.serieSap || "[Sin serie]"}
            </span>
          </div>
          <div className="flex flex-col items-end">
            <span className="text-[11px] font-medium text-gray-400 uppercase tracking-tight mb-1 text-right">
              Disponible
            </span>
            <span
              className={cn(
                "text-[12px] font-bold px-2 py-0.5 rounded-md",
                item.isAvailable ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600",
              )}
            >
              {item.isAvailable ? "Sí" : "No"}
            </span>
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-[12px] font-medium text-gray-400 uppercase tracking-tight mb-1">Tienda</span>
          <span className="text-[14px] font-medium text-gray-800">
            {item?.calculated?.sources?.length > 0
              ? item.calculated.sources.map((s: any) => `${s.id} (${s.name})`).join(", ")
              : item.almacen || "[Sin tienda]"}
          </span>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center pt-2 border-t border-gray-100">
        <div className="flex items-center gap-2">
          <span className="text-[13px] font-medium text-gray-500">Estado: {item.estadoOmnix || "N/A"}</span>
        </div>
        <div className="flex items-center gap-3">
          <Tooltip content="Vista rápida" align="top">
            <button
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onPreview(item)
              }}
              className="w-9 h-9 flex items-center justify-center bg-white hover:bg-gray-50 rounded-full text-indigo-500 hover:text-indigo-600 transition-all border border-gray-200 shadow-sm hover:shadow-md"
            >
              <HiOutlineEye className="text-lg" />
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  </div>
)

export default ListItemCard
